import cityCaptainVerification from "./cityCaptainVerification.component";

const cityCaptainVerificationModule = angular
  .module("app.components.cityCaptainVerification", [])
  .component("cityCaptainVerification", cityCaptainVerification);

export default cityCaptainVerificationModule;



// WEBPACK FOOTER //
// ./src/components/cityCaptainVerification/cityCaptainVerification.module.js